import React from "react";

export const Topics = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={44} height={28} rx={1} fill="#F1F2F6" />

    <g fill="#FF7826">
      <path d="M24.83,13.54l3.23-.38a6.12,6.12,0,0,0-2.29-4l-2,2.61A2.88,2.88,0,0,1,24.83,13.54Z" />
      <path d="M20.39,16.38a2.78,2.78,0,0,1-.33-.27l-2.3,2.3a5.86,5.86,0,0,0,.93.73Z" />
      <path d="M27.57,10.91l2.87-1.52a9.77,9.77,0,0,0-1.77-2.32L26.45,9.44A6.43,6.43,0,0,1,27.57,10.91Z" />
      <path d="M17.89,18.86a2.61,2.61,0,0,1-.3-.27l-2.3,2.3c.18.17.36.34.55.5Z" />
      <path d="M29.34,7.41l2.44-2.13q-.36-.41-.75-.78L28.82,6.88C29,7.05,29.17,7.23,29.34,7.41Z" />
      <path d="M32,5.46,29.51,7.6c.22.26.43.54.63.82l2.71-1.8A14.38,14.38,0,0,0,32,5.46Z" />
    </g>

    <g fill="#1CCB78">
      <path d="M19.18,13.45a2.85,2.85,0,0,1,1-1.66l-2-2.61A6.14,6.14,0,0,0,16,13Z" />
      <path d="M16.4,11c.08-.15.17-.29.26-.43L14,8.7a7.17,7.17,0,0,0-.46.75Z" />
      <path d="M14.12,8.49l2.69,1.83a3.58,3.58,0,0,1,.29-.39L14.64,7.81C14.46,8,14.28,8.26,14.12,8.49Z" />
      <path d="M16.29,11.17,13.41,9.68a9.31,9.31,0,0,0-.89,2.73l3.21.5A6.44,6.44,0,0,1,16.29,11.17Z" />
      <path d="M12.44,11.58a10.58,10.58,0,0,1,.35-1.13l-3-1.2a13.67,13.67,0,0,0-.5,1.57Z" />
      <path d="M10.33,8l2.9,1.46c.17-.32.35-.64.55-.94L11.09,6.71A13.12,13.12,0,0,0,10.33,8Z" />
    </g>

    <g fill="#90BE6D">
      <path d="M19.89,15.94a3.27,3.27,0,0,1-.43-.62L16.51,16.7a6.11,6.11,0,0,0,1.08,1.54Z" />
      <path d="M16.9,17.81a6.5,6.5,0,0,1-.6-1l-2.93,1.39a9.34,9.34,0,0,0,1,1.57Z" />
      <path d="M17.41,18.41a4.48,4.48,0,0,1-.36-.4l-2.56,2a8.29,8.29,0,0,0,.62.71Z" />
      <path d="M13.48,19c-.12-.2-.22-.4-.32-.6l-2.93,1.4c.14.29.3.58.47.87Z" />
    </g>

    <g fill="#C09A00">
      <path d="M19.12,14a1.54,1.54,0,0,1,0-.3l-3.23-.48a6.53,6.53,0,0,0,0,.78,6.14,6.14,0,0,0,.52,2.47l3-1.37A2.71,2.71,0,0,1,19.12,14Z" />
      <path d="M15.64,13.63c0-.16,0-.32,0-.47l-3.21-.5a7.89,7.89,0,0,0-.08.85Z" />
    </g>

    <g fill="#0A7DBC">
      <path d="M27.53,16.62A6,6,0,0,0,28.12,14c0-.2,0-.4,0-.59l-3.25.38a1.52,1.52,0,0,1,0,.21,2.86,2.86,0,0,1-.26,1.17Z" />
    </g>

    <g fill="#2AA8FF">
      <path d="M24.5,15.39A2.87,2.87,0,0,1,22,16.88a2.83,2.83,0,0,1-1.39-.38L18.9,19.27a6.06,6.06,0,0,0,3.1.85,6.14,6.14,0,0,0,5.42-3.27Z" />
      <path d="M25.29,19.45a6.34,6.34,0,0,1-3.17.92v3.25A9.58,9.58,0,0,0,27,22.19Z" />
      <path d="M19.68,19.93a3.79,3.79,0,0,1-.42-.18l-1.45,2.9c.25.12.49.23.75.33Z" />
      <path d="M19,19.64l-.33-.19L17,22.19a5.45,5.45,0,0,0,.62.35Z" />
      <path d="M25.25,23.31c-.31.11-.62.2-.94.28L25,26.76a12,12,0,0,0,1.33-.4Z" />
      <path d="M26.11,23l-.62.26,1.11,3.05c.3-.12.6-.24.9-.38Z" />
      <path d="M23.15,23.8c-.34,0-.68.06-1,.07v3.25a13.75,13.75,0,0,0,1.45-.1Z" />
    </g>

    <g fill="#DB4E69">
      <path d="M20.38,11.63a2.83,2.83,0,0,1,3.24,0L25.57,9a6.12,6.12,0,0,0-7.14,0Z" />
      <path d="M22.46,7.65A6.13,6.13,0,0,1,25,8.37l1.58-2.84a9.51,9.51,0,0,0-3.93-1.12Z" />
    </g>
  </g>
);
